module.exports = __webpack_public_path__ + "Lato-HairlineItalic.b4da0df63131b83ddeec.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-HairlineItalic.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-HairlineItalic.woff
// module chunks = styles